// NPM Imports
import React, { Component } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Toastr } from "@revvsales/components";

// Components Imports
import { ReactSelect } from "../../../../../commonComponents";

// Action Imports
import { AssetActions } from "../../../../../actions";

// Internal Imports
import { GlobalUtils } from "../../../../../utils";

// Destructuring
const { assetCollaboratorsAccessAction } = AssetActions;
const { handleApiErrMsg, readDataFromLocalStorage } = GlobalUtils;

const accessLevels = ["View", "Edit"];
const accessLevelsMap = {
  VIEW: "View",
  EDIT: "Edit",
};

class AssetAccessListing extends Component {
  state = { showBtnLoader: false, showDeleteBtnLoader: false };

  _changeAccess = (value, collaborator) => {
    if (value !== accessLevelsMap[collaborator.access_level]) {
      const {
        assetCollaboratorsAccess: assetChangeCollaboratorAccess,
      } = this.props;
      const payload = {
        inode_id: collaborator.inode_id,
        user: { id: collaborator.user.id },
        access_level: value ? value.toUpperCase() : "",
      };
      this.setState({ showBtnLoader: true });
      assetChangeCollaboratorAccess(payload, "CHANGE")
        .then(() => {
          Toastr.showToastr({
            type: "success",
            message: "Access updated successfully.",
            timeout: 2000,
          });
          this.setState({ showBtnLoader: false });
        })
        .catch(error => {
          console.error(
            `AssetCollaboratorPopup => _changeAccess => Error : ${error}`,
          );
          Toastr.showToastr({
            type: "failure",
            message: "Something went wrong. Please try again!",
            timeout: 3000,
          });
          this.setState({ showBtnLoader: false });
        });
    }
  };

  _deleteCollaboratorAccess = collaborator => {
    const {
      assetCollaboratorsAccess: assetDeleteCollaboratorAccess,
    } = this.props;
    const payload = {
      inode_id: collaborator.inode_id,
      user: { id: collaborator.user.id },
      access_level: "DENY",
    };
    this.setState({ showDeleteBtnLoader: true });
    assetDeleteCollaboratorAccess(payload, "DELETE")
      .then(() => {
        Toastr.showToastr({
          type: "success",
          message: `${
            this.props.assetItem ? this.props.assetItem.folderName : ""
          } access updated successfully.`,
          timeout: 2000,
        });
        this.setState({ showDeleteBtnLoader: false });
      })
      .catch(err => {
        Toastr.showToastr({
          type: "failure",
          message: handleApiErrMsg(err),
          timeout: 3000,
        });
        this.setState({ showDeleteBtnLoader: false });
      });
  };

  _getAssetItemOwner = () => {
    const { assetItem } = this.props;
    return (
      <div className="assetaccesslisting-row owner-row">
        <div className="assetaccesslisting-col">
          <div className="assetaccesslisting-userprofile-wrapper">
            <div className="assetaccesslisting-profileimage-wrapper">
              {assetItem &&
                assetItem.itemOwner &&
                assetItem.itemOwner.image_url && (
                  <img alt="Revv" src={assetItem.itemOwner.image_url} />
                )}
            </div>
            <div className="assetaccesslisting-profile-wrapper">
              <span className="assetaccesslisting-profile-name">
                {assetItem ? assetItem.itemOwner.name : "-"}
              </span>
              <span className="assetaccesslisting-profile-email">
                {assetItem ? assetItem.itemOwner.username : "-"}
              </span>
            </div>
          </div>
        </div>
        <div className="assetaccesslisting-col access-col">
          <span className="assetaccesslisting-ownertext-box">Owner</span>
        </div>
      </div>
    );
  };

  render() {
    const { collaborators } = this.props;
    const { showBtnLoader, showDeleteBtnLoader } = this.state;
    const CURRENT_USER = readDataFromLocalStorage("revvsalesUser");
    return (
      <div className="assetaccesslisting-container">
        <div className="assetcollaboratorpopup-form-title">
          Users Who Have Access
        </div>

        <div className="assetaccesslisting-userlist-container">
          {/* ---------- Asset Item Owner Section ---------- */}
          {this._getAssetItemOwner()}

          {/* ---------- Invited Users Section ---------- */}
          <div className="assetaccesslisting-row-wrapper">
            {collaborators.map(collaborator => (
              <div className="assetaccesslisting-row">
                <div className="assetaccesslisting-col">
                  <div className="assetaccesslisting-userprofile-wrapper">
                    <div className="assetaccesslisting-profileimage-wrapper">
                      <img alt="Revv" src={collaborator.user.image_url} />
                    </div>
                    <div className="assetaccesslisting-profile-wrapper">
                      <span className="assetaccesslisting-profile-name">
                        {collaborator.user.name || "-"}
                      </span>
                      <span className="assetaccesslisting-profile-email">
                        {collaborator.user.username || "-"}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="assetaccesslisting-col access-col">
                  <span className="assetaccesslisting-selectinput-box">
                    <ReactSelect
                      value={accessLevelsMap[collaborator.access_level]}
                      onChange={value =>
                        this._changeAccess(value.value, collaborator)
                      }
                      isDisabled={
                        (CURRENT_USER &&
                          CURRENT_USER.id === collaborator.user.id) ||
                        showBtnLoader
                      }
                      options={accessLevels}
                      data-test="assetaccesslisting-select"
                    />
                  </span>
                  {CURRENT_USER && CURRENT_USER.id !== collaborator.user.id && (
                    <span
                      className="btn-icon assetaccesslisting-delete-icon"
                      onClick={() =>
                        this._deleteCollaboratorAccess(collaborator)
                      }
                      onKeyPress={() => {}}
                      tabIndex="0"
                      role="button">
                      {showDeleteBtnLoader ? (
                        <FontAwesomeIcon
                          icon={["far", "spinner"]}
                          className="fa-spin"
                        />
                      ) : (
                        <FontAwesomeIcon icon={["far", "trash-alt"]} />
                      )}
                    </span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = {
  assetCollaboratorsAccess: assetCollaboratorsAccessAction,
};

export default connect(
  null,
  mapDispatchToProps,
)(AssetAccessListing);



// WEBPACK FOOTER //
// ./src/components/AssetWrapper/AssetDetails/AssetCollaboratorPopup/AssetAccessListing/index.js